import React from "react";
import { Box, Grid, MenuItem, Paper, Typography } from "@mui/material";
import { FormHandles } from "@unform/core";

import { LoadingComp } from "../../../../../shared/components/loading/Loading";
import { VForm, VTextField } from "../../../../../shared/forms";
import { VMaskTextField } from "../../../../../shared/forms/VMaskTextField";
import { ISimulateEditProposalAddress } from "../../../../../shared/services/api/proposal/ProposalEditService";

interface AddressTabProps {
	formRef: React.RefObject<FormHandles>;
	isLoading: boolean;
	editAddress: boolean;
	onSubmit: (dados: ISimulateEditProposalAddress) => void;
	onCheckCEP: (e: any) => void;
}

export const AddressTab: React.FC<AddressTabProps> = ({ formRef, isLoading, editAddress, onSubmit, onCheckCEP }) => {
	return (
		<Box>
			{isLoading && <LoadingComp isopen />}
			<VForm id="formIdSimulationAddress" onPointerEnterCapture={''} onPointerLeaveCapture={''} placeholder={''} ref={formRef} onSubmit={onSubmit}>
				<Box margin={0} display="flex" flexDirection="column" component={Paper} variant="elevation" elevation={0}>
					<Grid container item direction="column" padding={2} spacing={2}>
						<Grid container item direction="row" spacing={2}>
							<Grid item xs={11}>
								<Typography variant="h6" color={"primary"}>
									Alteração de endereço
								</Typography>
							</Grid>

							<Grid container item direction="row" spacing={2}>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VMaskTextField fullWidth label="CEP" name="addressZipcode" disabled={!editAddress} mask="cep" onBlur={onCheckCEP} />
								</Grid>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField fullWidth label="Rua" name="addressStreet" disabled={!editAddress} />
								</Grid>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField fullWidth label="Numero" name="addressNumber" disabled={!editAddress} />
								</Grid>
							</Grid>

							<Grid container item direction="row" spacing={2}>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField fullWidth label="Complemento" name="addressComplement" disabled={isLoading} />
								</Grid>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField fullWidth label="Bairro" name="addressDistrict" disabled={!editAddress} />
								</Grid>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField fullWidth label="Cidade" name="addressCity" disabled={!editAddress} />
								</Grid>
							</Grid>

							<Grid container item direction="row" spacing={2}>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField fullWidth label="Estado" name="addressState" disabled={!editAddress} select>
										<MenuItem value="AC">Acre</MenuItem>
										<MenuItem value="AL">Alagoas</MenuItem>
										<MenuItem value="AP">Amapá</MenuItem>
										<MenuItem value="AM">Amazonas</MenuItem>
										<MenuItem value="BA">Bahia</MenuItem>
										<MenuItem value="CE">Ceará</MenuItem>
										<MenuItem value="DF">Distrito Federal</MenuItem>
										<MenuItem value="ES">Espírito Santo</MenuItem>
										<MenuItem value="GO">Goiás</MenuItem>
										<MenuItem value="MA">Maranhão</MenuItem>
										<MenuItem value="MT">Mato Grosso</MenuItem>
										<MenuItem value="MS">Mato Grosso do Sul</MenuItem>
										<MenuItem value="MG">Minas Gerais</MenuItem>
										<MenuItem value="PA">Pará</MenuItem>
										<MenuItem value="PB">Paraíba</MenuItem>
										<MenuItem value="PR">Paraná</MenuItem>
										<MenuItem value="PE">Pernambuco</MenuItem>
										<MenuItem value="PI">Piauí</MenuItem>
										<MenuItem value="RJ">Rio de Janeiro</MenuItem>
										<MenuItem value="RN">Rio Grande do Norte</MenuItem>
										<MenuItem value="RS">Rio Grande do Sul</MenuItem>
										<MenuItem value="RO">Rondônia</MenuItem>
										<MenuItem value="RR">Roraima</MenuItem>
										<MenuItem value="SC">Santa Catarina</MenuItem>
										<MenuItem value="SP">São Paulo</MenuItem>
										<MenuItem value="SE">Sergipe</MenuItem>
										<MenuItem value="TO">Tocantins</MenuItem>
									</VTextField>
								</Grid>
								<Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
									<VTextField fullWidth label="Cód IBGE" name="addressIBGE" disabled={true} sx={{ border: "none" }} />
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Box>
			</VForm>
		</Box>
	);
};
